import { storyblokEditable } from "@storyblok/react";

const IntroLogo = ({ blok }) => {
  return (
      <div className="intrologo-wrap wrap" {...storyblokEditable(blok)}>
      <img src={blok.image.filename} alt={blok.image.alt} />
      </div>

  );
};

export default IntroLogo;
